// Brands data with EN + FR localised tagline + description.
export const BRANDS = [
  {
    n: "01",
    name: "Professional Designers",
    tagline: {
      en: "Web Design & Digital Marketing Agency",
      fr: "Agence de Design Web & Marketing Digital",
    },
    desc: {
      en: "A small (but smart) team of designers and developers building useful brands and refined websites — WordPress, e‑commerce and digital marketing experts.",
      fr: "Une petite (mais intelligente) équipe de designers et de développeurs qui créent des marques utiles et des sites web élégants. Experts en WordPress, e‑commerce et marketing numérique.",
    },
    url: "https://professionaldesigners.ch/",
    color: "#FF6B35",
    icon: "fa-pen-nib",
    category: "Agency",
  },
  {
    n: "02",
    name: "Brand Concepts",
    tagline: {
      en: "WordPress theme for creative agencies",
      fr: "Thème WordPress pour agences créatives",
    },
    desc: {
      en: "A free WordPress theme designed to help you build the website of your dreams — everything you need for a successful campaign while saving time and money.",
      fr: "Un thème WordPress gratuit conçu pour vous aider à créer le site web de vos rêves — tout ce qu'il faut pour une campagne réussie tout en économisant temps et argent.",
    },
    url: "https://brandconcepts.ch/",
    color: "#6366F1",
    icon: "fa-palette",
    category: "Theme",
  },
  {
    n: "03",
    name: "Bookers",
    tagline: {
      en: "Smart reservations & event management",
      fr: "Réservations & gestion d'événements intelligentes",
    },
    desc: {
      en: "All‑in‑one reservation and event platform for restaurants, bars and venues — streamline bookings, manage guests and grow your business.",
      fr: "Plateforme tout‑en‑un de réservation et d'organisation d'événements pour restaurants, bars et lieux de réception — simplifiez les réservations, gérez vos clients et développez votre activité.",
    },
    url: "https://wearebookers.com/",
    color: "#0EA5E9",
    icon: "fa-calendar-check",
    category: "SaaS",
  },
  {
    n: "04",
    name: "O'Javana",
    tagline: {
      en: "POS & online ordering",
      fr: "Caisse & commande en ligne",
    },
    desc: {
      en: "Run restaurants and retail more efficiently with integrated payment terminals and online ordering — built for speed, accuracy and revenue.",
      fr: "Gérez restaurants et commerces plus efficacement grâce à des terminaux de paiement intégrés et la commande en ligne — pensé pour la rapidité, la précision et le chiffre d'affaires.",
    },
    url: "https://ojavana.com/",
    color: "#B45309",
    icon: "fa-mug-hot",
    category: "POS",
  },
  {
    n: "05",
    name: "SocialBase",
    tagline: {
      en: "All marketing in one place",
      fr: "Tout le marketing au même endroit",
    },
    desc: {
      en: "We don't believe in guesswork. Data analysis, campaign monitoring and continuous tuning to maximise ROI on your digital marketing.",
      fr: "Nous ne croyons pas aux suppositions. Analyse des données, suivi des campagnes et ajustements continus pour maximiser le ROI de votre marketing digital.",
    },
    url: "https://socialbase.ch/",
    color: "#EC4899",
    icon: "fa-bullhorn",
    category: "Marketing",
  },
  {
    n: "06",
    name: "Chaslay",
    tagline: {
      en: "Online ordering & delivery platform",
      fr: "Plateforme de commande & livraison en ligne",
    },
    desc: {
      en: "A simple, no‑tech‑knowledge‑needed POS, web shop and QR‑code ordering system for restaurants and food operations.",
      fr: "Un système simple — sans connaissance technique — de caisse, boutique en ligne et commande par QR code pour la restauration.",
    },
    url: "http://chaslay.com/",
    color: "#059669",
    icon: "fa-utensils",
    category: "Platform",
  },
  {
    n: "07",
    name: "Connector",
    tagline: {
      en: "All‑in‑one CRM & growth stack",
      fr: "CRM & stack de croissance tout‑en‑un",
    },
    desc: {
      en: "CRM, email & SMS marketing, landing pages, appointment booking, funnel building — operations and growth in one cohesive system.",
      fr: "CRM, e‑mailing, SMS, pages d'atterrissage, prise de rendez‑vous, tunnels de vente — opérations et croissance dans un système unifié.",
    },
    url: "https://helloconnector.com/",
    color: "#06B6D4",
    icon: "fa-diagram-project",
    category: "CRM",
  },
  {
    n: "08",
    name: "SwissPayout",
    tagline: {
      en: "Accept payments easily and securely",
      fr: "Acceptez les paiements simplement et en toute sécurité",
    },
    desc: {
      en: "200+ payment methods, plugins for every shop system, no website or coding required to request and receive payments.",
      fr: "Plus de 200 méthodes de paiement, plugins pour toutes les boutiques, ni site web ni programmation requis pour demander et recevoir des paiements.",
    },
    url: "https://swisspayout.ch/",
    color: "#DC2626",
    icon: "fa-credit-card",
    category: "Payments",
    featured: true,
  },
  {
    n: "09",
    name: "Sentricor",
    tagline: {
      en: "Intelligent website security",
      fr: "Sécurité intelligente pour vos sites web",
    },
    desc: {
      en: "Test sites against 2 000+ vulnerabilities and remediate issues in staging and production the moment they're found.",
      fr: "Testez vos sites contre 2 000+ vulnérabilités et corrigez les problèmes en pré‑production et en production dès leur détection.",
    },
    url: "https://sentricor.ch/",
    color: "#1E293B",
    icon: "fa-shield-halved",
    category: "Security",
  },
];
